import * as HttpStatus from 'http-status-codes'
import { useState } from 'react'
import { Identifier, Labeled, usePermissions } from 'react-admin'
import { FlexBox } from 'shared/components/Base/FlexBox'
import { Text } from 'shared/components/Text/Text'

import { BaseUploadButton } from 'components/Common/UploadButton'
import { parsedTrailerInvoices } from '../../api/accounting'
import { hasPermission, Permissions } from '../../Permissions'

const TrailerInvoiceParsing = () => {
  const [extractedFileUrl, setExtractedFileUrl] = useState(null)
  const [extractedFileName, setExtractedFileName] = useState(null)
  const { permissions } = usePermissions()
  const canParseTrailerInvoices = hasPermission(permissions || [], Permissions.TrailerInvoiceParsing)

  if (!canParseTrailerInvoices) {
    return <Text variant="paragraph0">You do not have permission to use this feature</Text>
  }

  function upload(id: Identifier, formData: any) {
    return parsedTrailerInvoices(id, formData).then((response) => {
      if (response.status === HttpStatus.OK) {
        const file_url = response.data['extracted_invoices_file']
        const filename_with_creds = file_url.split('/').pop()
        // strip any extraneous params from the url
        const file_name = filename_with_creds.split('?')[0]
        setExtractedFileUrl(file_url)
        setExtractedFileName(file_name)
      }
    })
  }

  return (
    <FlexBox gap="10px" isColumn>
      <FlexBox isColumn>
        <Text variant="header1" align="left">
          Trailer Invoice Parsing
        </Text>
        <Text variant="paragraph0" align="left">
          Upload trailer rental invoices to get a csv document of parsed trailer data.
        </Text>
        <Text variant="paragraph0" align="left">
          <b>Note:</b> Only works for Metro invoices at the moment.
        </Text>
      </FlexBox>
      <FlexBox isColumn alignItems="flex-start">
        <BaseUploadButton
          record={{ id: '' }}
          uploadFunction={upload}
          fileFieldInputs={[{ name: 'trailer_invoices' }]}
          dialogTitle="Parse Trailer Rental Invoices"
          buttonLabel="Upload Trailer Rentals"
          buttonVariant="text"
          multiple={true}
        />
      </FlexBox>
      {extractedFileUrl && (
        <FlexBox isColumn>
          <Labeled label="Download File">
            <a download={extractedFileName} href={extractedFileUrl}>
              {extractedFileName}
            </a>
          </Labeled>
        </FlexBox>
      )}
    </FlexBox>
  )
}

export default TrailerInvoiceParsing
